import { createRouter, createWebHistory } from 'vue-router';
import { TOKEN } from '@/utils/CacheKey';
import { getCache } from '@/utils/LocalCache';
import { useMenusStore } from "@/stores/menu";

const routes = [
    { path: '/', redirect: '/login' },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login.vue')
    },
    {
        path: '/layout',
        name: 'layout',
        redirect: '/layout/home/control',
        component: () => import('@/views/layout/index.vue'),
        children: []
    },
    { path: '/404', name: '404', component: () => import('@/views/404.vue') },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});
const Whitelist = ['/', '/login', '/error', '/404'];
router.beforeEach((to, from, next) => {
    const token = getCache(TOKEN);
    const store = useMenusStore();

    if (to.name === "login" && token) {
        return next({ name: 'layout' });
    }

    // 不在白名单内，需要权限校验
    if (Whitelist.indexOf(to.path) === -1) {
        if (store.menuRouter.length === 0 && token) {
            store.generateRoutes().then(() => {
                const routerlist = store.menuRouter;
                router.addRoute(// 添加路由
                    {
                        path: '/layout',
                        name: 'layout',
                        redirect: '/layout/home/control',
                        component: () => import('@/views/layout/index.vue'),
                        children: routerlist
                    }
                );

                return next({ ...to, replace: true });
            });
        } else {
            if (token && to.matched.length !== 0) {
                return next();
            } else {
                if (!token) {
                    return next({ name: 'login' });
                } else {
                    return next({ name: '404' });
                }
            }
        }
    } else {
        return next();
    }
});

export default router;